import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	checkNotifications: {
		id: 'atlassian-navigation.notifications.command-palette.check-notifications',
		defaultMessage: 'Check notifications',
		description: 'Command name in the command palette to open notifications dropdown',
	},
});
